// modules
import * as R from 'ramda'
import extractPeaks from 'webaudio-peaks'
// const
const sampleCount = 35

const getVoicePeaks = file =>
  new Promise(resolve => {
    const reader = new FileReader()
    reader.readAsArrayBuffer(file)
    // TODO: reader.addEventListener('error', reject)
    reader.onload = () => resolve(reader.result)
  }).then(
    buffer =>
      new Promise(resolvePromise => {
        const audioCtx = new (window.AudioContext ||
          window.webkitAudioContext)()

        audioCtx.decodeAudioData(buffer, decodedData => {
          const { data } = extractPeaks(decodedData, 1000, true)
          resolvePromise(data[0])
        })
      }),
  )

const calculateListAverage = list =>
  R.length(list) ? R.reduce(R.add, 0, list) / R.length(list) : 0

const relaxPeaks = peaks => {
  const avg = calculateListAverage(peaks)
  if (avg < 64) return R.map(R.add(25), peaks)
  return peaks
}

export const getVoiceWave = file =>
  getVoicePeaks(file).then(
    R.compose(
      R.map(R.clamp(25, 128)),
      relaxPeaks,
      R.map(R.compose(R.multiply(2), Math.floor, calculateListAverage)),
      R.take(sampleCount),
      peaks => R.splitEvery(peaks.length / sampleCount, peaks),
      R.map(Math.abs),
    ),
  )
